import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import DOMPurify from 'dompurify'

// Renders rich-text (Quill) HTML after DOMPurify sanitization. Defence-in-depth
// for the unpatched Quill HTML-export XSS (GHSA-v3m3-f69x-jf25): DOMPurify strips
// scripts / event handlers / javascript: URLs while keeping standard formatting,
// then we mark the cleaned string trusted so Angular renders it as-is.
@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    const clean = DOMPurify.sanitize(value ?? '')
    return this.sanitizer.bypassSecurityTrustHtml(clean)
  }
}
